import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './Item.module.css';

const bindClasses = classNameBind.bind(styles);

const Item = ({
  children,
  dataId = 'OrderedList.Item',
}) => (
  <li
    className={bindClasses('item')}
    data-ppuc-id={dataId}
  >
    {children}
  </li>
);

Item.displayName = 'OrderedList.Item';

export { Item };
